module.exports = __webpack_public_path__ + "media/img/patient-hero-73b0d5cb9fd9dd0fb539f4ea8777851f.jpg";